import React from 'react';
import { HiOutlinePencil } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Center,
  Flex,
  Icon,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import { useGetCategoriesQuery } from '@spartalabs/pdc-core';
import { CardSkele } from 'components/Skeletons/Card';
import { AutoComplete } from './components/autocomplete';

interface SearchProps {
  canEdit?: boolean;
  id?: string;
  title?: string;
  desc?: string;
  direction?: string | number;
  titleLoading?: boolean;
}

export const FaQSearch: React.FC<SearchProps> = ({
  canEdit,
  id,
  title,
  desc,
  direction,
  titleLoading,
}) => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetCategoriesQuery();

  return (
    <Flex
      borderRadius="8px"
      mx={{ md: '24px', base: '16px' }}
      bg="grey.200"
      flexDir="column"
      py={{ md: '40px', base: '24px' }}
      px="16px"
    >
      <Flex display={{ md: 'flex', base: 'none' }} mt="-20px">
        {direction && (
          <Button
            w="80px"
            /*  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
       //@ts-ignore */
            onClick={() => navigate(direction)}
            variant="outline"
          >
            Voltar
          </Button>
        )}

        {canEdit && (
          <Button
            bg="transparent"
            onClick={() =>
              id
                ? navigate(`/centraldeduvidas/pergunta/editar/${id}`)
                : navigate('/centraldeduvidas/editarcategorias')
            }
            _hover={{ bg: 'grey.300' }}
            ml="auto"
            borderRadius="4px"
            w="40px"
            h="40px"
            border="1px solid"
            borderColor="mutable.100"
          >
            <Icon w="24px" h="24px" color="mutable.100" as={HiOutlinePencil} />
          </Button>
        )}
      </Flex>

      {titleLoading ? (
        <Center gap="24px" flexDir="column">
          <CardSkele align="center" mx="auto" w={{ md: '400px', base: '80%' }}>
            <Skeleton h="42px" />
          </CardSkele>
          <CardSkele align="center" mx="auto" w={{ md: '360px', base: '70%' }}>
            <Skeleton h="22px" />
          </CardSkele>
        </Center>
      ) : (
        <Flex display={{ md: 'block', base: 'flex' }}>
          <Box>
            <>
              <Text
                textAlign={{ md: 'center', base: 'start' }}
                color="button"
                mr={{ md: '0px', base: '40px' }}
                fontSize={{ md: '32px', base: '20px' }}
                fontWeight={600}
              >
                {title || 'Como podemos te ajudar?'}
              </Text>
              <Text
                textAlign={{ md: 'center', base: 'start' }}
                mr={{ md: '0px', base: '40px' }}
                mt="8px"
                color="text.100"
              >
                {desc || 'Você pode encontrar informações importantes a baixo.'}
              </Text>
            </>
          </Box>
          <Flex
            gap="8px"
            justifyContent="center"
            display={{ md: 'none', base: 'flex' }}
            ml="auto"
          >
            {direction && (
              <Button
                w="60px"
                /*  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
       //@ts-ignore */
                onClick={() => navigate(direction)}
                variant="outline"
              >
                Voltar
              </Button>
            )}
            {canEdit && (
              <Button
                mx="auto"
                bg="transparent"
                onClick={() =>
                  id
                    ? navigate(`/centraldeduvidas/pergunta/editar/${id}`)
                    : navigate('/centraldeduvidas/editarcategorias')
                }
                _hover={{ bg: 'grey.300' }}
                ml="auto"
                borderRadius="4px"
                w="40px"
                h="40px"
                border="1px solid"
                borderColor="gray.100"
              >
                <Icon w="24px" h="24px" color="black" as={HiOutlinePencil} />
              </Button>
            )}
          </Flex>
        </Flex>
      )}
      {data && !isLoading && <AutoComplete data={data} />}
    </Flex>
  );
};
